import { render, staticRenderFns } from "./userDetailView.vue?vue&type=template&id=48e5ff57&scoped=true"
import script from "./userDetailView.vue?vue&type=script&lang=js"
export * from "./userDetailView.vue?vue&type=script&lang=js"
import style0 from "./userDetailView.vue?vue&type=style&index=0&id=48e5ff57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e5ff57",
  null
  
)

export default component.exports